import { QBConnectionType } from './enums';

export class TableFilter {
  originating: boolean = false;
  reviewer: boolean = false;
  primary: boolean = false;
  involved: boolean = false;
  scopeAccount: string = '';
  archived: boolean = false;
  search: string = '';
  showOrphans: boolean = false;
  checkQuickbooks: boolean = false;
  qbConnectionType: QBConnectionType = QBConnectionType.Any;
}

export class ClientTableFilter extends TableFilter {
  clientId: string = '';
  showSecondarySplitMatter: boolean = true;
}

export class MatterTableFilter extends TableFilter {
  expenseInterest: boolean = false;
  billingType: string = '';
  matterTag: string = '';
  clientId: string | null = null;
  showSecondarySplitMatter: boolean = true;
}
